// extracted by mini-css-extract-plugin
export default {"list":"lawyer_keywords-module__list--1p_Dh","item":"lawyer_keywords-module__item--wqFSl"};